import { createFileRoute } from '@tanstack/react-router';
import { SelectProduct } from '@/pages';

export const Route = createFileRoute('/_authenticated/campaign/$id/select-product')({
  component: SelectProduct,
});
